import { z } from 'zod';

export const LoginInfo = z.object({
  atsUrl: z.string(),
  billingSyncUrl: z.string(),
  coreUrl: z.string(),
  documentEditorUrl: z.string(),
  mobileUrl: z.string(),
  oauthUrl: z.string(),
  restUrl: z.string(),
  samlUrl: z.string(),
  novoUrl: z.string(),
  pulseInboxUrl: z.string(),
  canvasUrl: z.string(),
  npsSurveyUrl: z.string(),
  ulUrl: z.string(),
  dataCenterId: z.number(),
  superClusterId: z.number(),
});
export type LoginInfo = z.infer<typeof LoginInfo>;

export const AccessToken = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
});
export type AccessToken = z.infer<typeof AccessToken>;

export const RefreshToken = z.object({
  BhRestToken: z.string(),
  restUrl: z.string(),
});
export type RefreshToken = z.infer<typeof RefreshToken>;

export const Identity = z.object({
  username: z.string(),
  masterUserId: z.number(),
  userId: z.number(),
  corporationId: z.number(),
  privateLabelId: z.number(),
  userTypeId: z.number(),
  userPrimaryDepartmentId: z.number(),
  swimLaneId: z.number(),
  dataCenterId: z.number(),
  name: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  locale: z.string(),
  corporationName: z.string(),
  allPrivateLabelIds: z.number().array(),
  isPasswordCaseSensitive: z.boolean(),
  eStaffAgencyId: z.string(),
  userTypeName: z.string(),
  departmentName: z.string(),
});
export type Identity = z.infer<typeof Identity>;

export const Session = z.object({
  name: z.string(),
  value: z.object({
    token: z.string().optional(),
    endpoint: z.string(),
  }),
});
export type Session = z.infer<typeof Session>;

export const UniversalLogin = z.object({
  requestUrl: z.string(),
  redirectUrl: z.string(),
  identity: Identity,
  sessions: Session.array(),
  apps: z
    .object({
      enabled: z.boolean(),
    })
    .array(),
});
export type UniversalLogin = z.infer<typeof UniversalLogin>;
